// extracted by mini-css-extract-plugin
export default {"root":"NotFoundPage_root__iVUm-","contentContainer":"NotFoundPage_contentContainer__B1dCT","logo":"NotFoundPage_logo__REeOG","frontPageButton":"NotFoundPage_frontPageButton__mec07"};